const apiKey = import.meta.env.VITE_GOOGLE_MAPS_KEY;
export const apiUrl = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places&v=weekly&loading=async`;

export const ADDRESS_COMPONENT_TYPES = [
  'administrative_area_level_1',
  'administrative_area_level_2',
  'locality',
  'neighborhood',
  'postal_code',
  'postal_code_suffix',
  'route',
  'street_number',
] as const;

export const DEFAULT_OPTIONS: google.maps.places.AutocompleteOptions = {
  componentRestrictions: { country: 'us' },
  types: ['geocode'],
  fields: ['place_id', 'formatted_address', 'name', 'geometry.location', 'address_components'],
};
